import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      <div data-testid="payment-cancel" className="bg-white rounded-3xl border border-slate-200 p-10">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto" />
        <h1 className="font-display text-2xl font-bold text-slate-900 mt-4">Payment cancelled</h1>
        <p className="text-slate-500 text-sm mt-3">No worries — your booking wasn't charged. You can try again whenever you're ready.</p>
        <Link to="/"><Button className="mt-6 rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold px-8">Back to home</Button></Link>
      </div>
    </div>
  );
}
